/**
 * Pre-compiled en messages for ComboBox
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  clearSelection: `Clear selection`,
  options: `Options menu`,
  selectedValues: `Selected values`,
  toggleOptions: `Toggle options`,
};
